<template>
  <div class="c-card-wrapper">
    <DeleteComfirmComp
      v-if="deleteDeviceShowed"
      @close="deleteDeviceShowed = false"
      :dataId="deleteData.deviceId"
      description="This action will be delete all sensor related with this device"
      question="Are you sure to delete this device?"
      title="Delete Device"
      :loading="deleteLoading"
      @delete="deleteApi"
      :error="deleteError"
    ></DeleteComfirmComp>
    <DeviceFormLayout
      titleForm="Device Form"
      v-if="deviceFormShowed"
      @close="deviceFormShowed = false"
      :title="deviceFormTitle"
      :btn-title="deviceFormBtnTitle"
      :isEdit="editForm"
      @action="actionForm"
      :error="error"
      :loading="loading"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Device Id"
            outlined
            dense
            hide-details
            class="c-text-field"
            v-model="deviceData.deviceId"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Device Name"
            outlined
            dense
            hide-details
            class="c-text-field"
            v-model="deviceData.deviceName"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Description"
            outlined
            dense
            hide-details
            class="c-text-field"
            v-model="deviceData.description"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Default calibration"
            outlined
            dense
            hide-details
            class="c-text-field"
            v-model="deviceData.defaultCalibration"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Precision"
            outlined
            dense
            hide-details
            v-model="deviceData.precision"
            type="number"
            max="5"
            min="0"
            class="c-text-field"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Interval"
            outlined
            dense
            hide-details
            v-model="deviceData.interval"
            type="number"
            min="0"
            class="c-text-field"
          ></v-text-field>
        </v-col>
      </v-row>
    </DeviceFormLayout>
    <v-card elevation="2" :loading="loadingForm">
      <div class="header-card-wrapper">
        <v-card-title>Devices</v-card-title>
      </div>
      <div class="action-top">
        <p style="margin: 0" class="">List Devices</p>
        <v-btn
          rounded
          small
          depressed
          class="c-btn-primary"
          @click="createAction"
        >
          Create Device
        </v-btn>
      </div>
      <div class="body-card-wrapper">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="max-width: 25px; width: 25px"></th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Name
                </th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Description
                </th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Created At
                </th>
                <th
                  class="text-left"
                  style="max-width: 150px; word-wrap: break-word"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody class="tbody-card-wrapper">
              <tr v-for="item in devices" :key="item.name" class="tr-hover">
                <td>
                  <v-icon large> mdi-cpu-32-bit </v-icon>
                </td>
                <td
                  style="
                    max-width: 150px;
                    word-wrap: break-word;
                    cursor: pointer;
                  "
                  class="td-select"
                >
                  <router-link :to="`/dashboard/${item.deviceId}`">
                    {{ item.deviceName }}
                  </router-link>
                </td>
                <td style="max-width: 150px; word-wrap: break-word">
                  {{ item.description }}
                </td>
                <td style="max-width: 150px; word-wrap: break-word">
                  {{ item.createdAt }}
                </td>
                <td style="max-width: 150px; word-wrap: break-woMiningrd">
                  <v-btn
                    @click="editAction(item.deviceId)"
                    elevation="2"
                    color="transparent"
                    class="v-no-background-hover btn-action"
                    style="box-shadow: none !important"
                  >
                    <v-icon> mdi-pencil-outline </v-icon>
                  </v-btn>
                  <v-btn
                    elevation="2"
                    color="transparent"
                    class="v-no-background-hover btn-action"
                    style="box-shadow: none !important"
                    @click="deleteAction(item.deviceId)"
                  >
                    <v-icon> mdi-trash-can </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <div class="footer-card-wrapper">
        <p class="pagination-detail">
          Display page {{ page }} of {{ totalPage }}
        </p>
        <PaginationComp :page="page" :totalPage="totalPage" @next="next" @prev="prev"></PaginationComp>
      </div>
    </v-card>
  </div>
</template>

<script>
import DeleteComfirmComp from "@/components/elements/DeleteConfirmComp.vue";
import DeviceFormLayout from "@/components/layout/FormLayout.vue";
import PaginationComp from "@/components/elements/PaginationComp.vue";
import createDevice from "@/api/createDevice";
import listDevice from "@/api/listDevice";
import editDevice from "@/api/editDevice";
import deleteDevice from '@/api/deleteDevice';

export default {
  methods: {
    createAction() {
      this.deviceFormTitle = "Create Device";
      this.deviceFormBtnTitle = "Save";
      this.deviceFormShowed = true;
      this.editForm = false;
      this.isEdit = false;

      this.deviceData.deviceName = "";
      this.deviceData.deviceId = "";
      this.deviceData.description = "";
      this.deviceData.defaultCalibration = "";
      this.deviceData.precision = 0;
      this.deviceData.interval = 0;
    },
    editAction(deviceId) {
      const d = this.devices.filter((d) => d.deviceId == deviceId).at(0);
      this.deviceFormTitle = "Edit Device";
      this.deviceFormBtnTitle = "Save";
      this.deviceFormShowed = true;
      this.editForm = true;
      this.isEdit = true;

      this.deviceData.deviceName = d.deviceName;
      this.deviceData.deviceId = d.deviceId;
      this.deviceData.description = d.description;
      this.deviceData.defaultCalibration = d.defaultCalibration;
      this.deviceData.precision = d.precision;
      this.deviceData.interval = d.interval;
    },
    deleteAction(deviceId) {
      this.deleteDeviceShowed = true;
      this.deleteData.deviceId = deviceId;
    },
    async deleteApi(){
      this.deleteLoading = true;
     const res =  await deleteDevice(this.deleteData.deviceId);
     this.loadData(true, this.page);
     this.deleteLoading = true;
     if(res.status == '00'){
        this.deleteDeviceShowed = false;
     }else{

     }
    },
    async actionForm() {
      this.error = "";
      this.loading = true;
      const res = this.isEdit
        ? await editDevice(this.deviceData)
        : await createDevice(this.deviceData);
      this.loading = false;
      if (res == null) {
        this.error = "Server Error";
        return;
      } else if (res.error != null) {
        this.error = res.error.title;
        return;
      }
      this.loadData(true, this.isEdit ? this.page : 1);
      this.deviceFormShowed = false;
    },
    async loadData(forceLoad = false, page = 1) {
      if (this.$store.getters.getCurrentDevice.length == 0 || forceLoad) {
        this.loadingForm = true;
        const devices = await listDevice(page);
        this.loadingForm = false;
        if (
          devices == null ||
          devices.data == null ||
          devices.data == undefined
        )
          return;
        this.$store.commit("setCurrentDevice", devices.data.data);
        this.$store.commit("setDevicePage", devices.data.page);
        this.$store.commit("setDeviceTotalPage", devices.data.totalPage);
      }
      this.devices = this.$store.getters.getCurrentDevice;
      this.page = this.$store.getters.getDevicePage;
      this.totalPage = this.$store.getters.getDeviceTotalPage;
    },
    prev(){
      if(this.page <= 1) return;
      this.loadData(true, this.page-1)
    },
    next(){
      if(this.page >= this.totalPage) return;
      this.loadData(true, this.page+1)
    }
  },
  data() {
    return {
      isEdit: true,
      deviceFormTitle: "Create Device",
      deviceFormBtnTitle: "Create",
      deviceFormShowed: false,
      deleteDeviceShowed: false,
      editForm: false,
      deleteLoading: false,
      deleteError: '',

      deleteData:{
        deviceId: ''
      },

      loading: false,
      loadingForm: false,

      deviceData: {
        deviceName: "",
        deviceId: "",
        description: "",
        defaultCalibration: "",
        precision: 0,
        interval: 0,
      },
      error: "",
      devices: [],
      page: 1,
      totalPage: 1,
    };
  },
  components: { DeleteComfirmComp, DeviceFormLayout, PaginationComp },
  async created() {
    this.loadingForm = true
    await this.loadData();
    this.loadingForm = false
  },
};
</script>
